// extracted by mini-css-extract-plugin
export default {"TechHeader":"tech-header_TechHeader__zMXv4","TechHeader__links":"tech-header_TechHeader__links__3uLJU"};